import React, { Component, Fragment, MouseEvent } from 'react';
import { Trans } from 'react-i18next';
import { FormikProps } from 'formik';
import { Button, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import CircleIcon from '@material-ui/icons/Lens';

import { IGroupForm } from '../../types';
import ColorPicker from './ColorPicker';
import ImageChange from './ImageChange';
import ImagePicker from './ImagePicker';
import Image from './Image';

interface IProps extends WithStyles<typeof styles> {
  hexColor: string;
  formikProps: FormikProps<IGroupForm>;
  width: number;
}

interface IState {
  colorAnchorEl: HTMLElement;
  imagePickerOpen: boolean;
}

const styles = (theme: Theme) =>
  createStyles({
    colorIcon: {
      fontSize: 30,
    },
    colorButton: {
      paddingLeft: 0,
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(5),
      fontWeight: theme.typography.fontWeightBold,
    },
  });

class FormRight extends Component<IProps, IState> {
  state: IState = {
    colorAnchorEl: null,
    imagePickerOpen: false,
  };

  handleColorClick = (event: MouseEvent<HTMLButtonElement>) => {
    this.setState({ colorAnchorEl: event.currentTarget });
  };

  handleColorClose = () => {
    this.setState({ colorAnchorEl: null });
  };

  handleImageToggle = () => {
    const { imagePickerOpen } = this.state;
    this.setState({ imagePickerOpen: !imagePickerOpen });
  };

  render() {
    const { classes, formikProps, hexColor, width } = this.props;
    const { colorAnchorEl, imagePickerOpen } = this.state;

    return (
      <Fragment>
        <Typography gutterBottom variant="body2">
          <Trans i18nKey="groups:image" />
        </Typography>
        <ImageChange onToggle={this.handleImageToggle}>
          <Image size={width} hexColor={hexColor} formikProps={formikProps} />
        </ImageChange>
        <ImagePicker
          formikProps={formikProps}
          open={imagePickerOpen}
          hexColor={hexColor}
          onClose={this.handleImageToggle}
        />
        <Button
          className={classes.colorButton}
          color="inherit"
          onClick={this.handleColorClick}
          startIcon={<CircleIcon className={classes.colorIcon} style={{ color: hexColor }} />}>
          <Trans i18nKey="groups:color" />
        </Button>
        <ColorPicker
          formikProps={formikProps}
          hexColor={hexColor}
          anchorEl={colorAnchorEl}
          onClose={this.handleColorClose}
        />
      </Fragment>
    );
  }
}

export default withStyles(styles)(FormRight);
